import {BaSeErrorPage} from "@base/react"
import {useEffect} from "react";
import ToastContent from "../../components/toastContent";
import {toast} from "react-toastify";

const Unauthorized = () => {

  useEffect(() => {
    const error = localStorage.getItem("error") || null
    if (error && error === '409') {
      toast.warn(
        <ToastContent
          title="Sessão encerrada"
          description={"Sua conta foi acessada em outro dispositivo."}
        />,
        {
          autoClose: 5000,
          pauseOnFocusLoss: false,
        }
      )
      localStorage.removeItem("error")
    }
  }, [])

  return (
    <BaSeErrorPage
      error={`Infelizmente sua conta está impossibilitada de utilizar nossa ferramenta. Por favor, entre em contato conosco.`}
      title="Acesso negado"
      button={{
        leftIcon: 'device/phone-line',
        onClick: () => {window.open("https://sacnacional.sebrae.com.br/",'_blank')},
        value: 'Fale conosco'
      }}
    />
  )
}

export default Unauthorized
